module.exports = __webpack_public_path__ + "img/confirmed-gray-icon.27a4da77.png";